module.exports = "/images/vendor/flag-icon-css/flags/1x1/cd.svg?b43f872e1441147e938995ee5a709e19";